const HEADERS = [
  { text: '#', value: 'index', align: 'center', width: 35, sortable: false, divider: true },
  { text: 'Fecha requisición', sortable: true, value: 'requisitionDateRequisition', align: 'center', divider: true, filterType: 'date' },
  { text: 'Fecha orden de compra', sortable: true, value: 'dateOC', align: 'center', divider: true, filterType: 'date' },
  { text: 'Costo ACO sin IVA', sortable: true, value: 'costWithoutVat', align: 'center', filterType: 'money', divider: true },
  { text: 'Descuento sin IVA', sortable: true, value: 'discountWithoutVat', align: 'center', filterType: 'money', divider: true },

  { text: 'Siniestro', sortable: true, value: 'sinisterNumber', align: 'center', divider: true, width: 100, class: 'blue darken-2' },
  { text: 'Supervisor', sortable: true, value: 'supervisor', align: 'center', divider: true, class: 'blue darken-2' },
  { text: 'DIV', sortable: true, value: 'divisionName', align: 'center', divider: true, class: 'blue darken-2' },
  { text: 'UDN', sortable: true, value: 'businessUnit', align: 'center', divider: true, class: 'blue darken-2' },
  { text: 'Proveedor', sortable: true, value: 'providerName', align: 'center', divider: true, class: 'blue darken-2' },
  { text: 'Cliente', sortable: true, value: 'customer', align: 'center', divider: true, class: 'blue darken-2' },

  { text: 'Folio', sortable: true, value: 'folio', align: 'center', divider: true, width: 100, class: 'blue lighten-2' },
  { text: 'Fecha de pago', sortable: true, value: 'oldestPaymentDate', align: 'center', divider: true, width: 100, class: 'blue lighten-2', filterType: 'date' },
  { text: 'Monto sin IVA', sortable: true, value: 'amountWithoutVat', align: 'center', divider: true, filterType: 'money', class: 'blue lighten-2' },
  { text: 'Total neto', sortable: true, value: 'amountTotal', align: 'center', divider: true, filterType: 'money', class: 'blue lighten-2' },
  { text: 'Tiempo de entrega', sortable: true, value: 'deliveryDays', align: 'center', divider: true, class: 'blue lighten-2' },
  { text: 'Fecha estimada de entrega', sortable: true, value: 'estimatedDeliveryDate', align: 'center', divider: true, class: 'blue lighten-2', filterType: 'date' },
  { text: 'Fecha de notificación', sortable: true, value: 'notificationDate', align: 'center', divider: true, class: 'blue lighten-2', filterType: 'date' },
  { text: 'Días reales entrega', sortable: true, value: 'actualDeliveryDays', align: 'center', divider: true, class: 'blue lighten-2' },
  { text: 'Fecha de recolección', sortable: true, value: 'collectionDate', align: 'center', divider: true, class: 'blue lighten-2', filterType: 'date' },
  { text: 'Días Rec Supervisor', sortable: true, value: 'daysRecSupervisor', align: 'center', divider: true, class: 'blue lighten-2' },
  { text: 'Estatus de compra', sortable: true, value: 'ocStatus', align: 'center', divider: true, class: 'blue lighten-2' },
  { text: 'Estatus siniestro', sortable: true, value: 'sinisterStatus', align: 'center', divider: true, class: 'blue lighten-2' },
  { text: 'Facturado', sortable: true, value: 'invoice', align: 'center', divider: true, class: 'blue lighten-2' },

  { text: 'Devolución', sortable: true, value: 'isReturn', align: 'center', divider: true, class: 'green lighten-2' },
  { text: '', sortable: false, value: 'actions', align: 'center', divider: true }
]

const CONCEPTS_HEADERS = [
  { text: 'Descripción', sortable: true, value: 'description', align: 'center', divider: true, class: 'yellow darken-2' },
  { text: 'Tipo', sortable: true, value: 'kind', align: 'center', divider: true, class: 'yellow darken-2' },
  { text: 'Precio unitario', sortable: true, value: 'unitPrice', align: 'center', divider: true, class: 'yellow darken-2' },
  { text: 'Cantidad', sortable: true, value: 'quantity', align: 'center', divider: true, class: 'yellow darken-2' },
  { text: 'Total', sortable: true, value: 'total', align: 'center', divider: true, class: 'yellow darken-2' }
]
const FREIGHTS_HEADERS = [
  { text: 'Proveedor', sortable: true, value: 'freightProvider', align: 'center', divider: true, class: 'purple lighten-3' },
  { text: 'Guía rastreo', sortable: true, value: 'dragGuide', align: 'center', divider: true, class: 'purple lighten-3' },
  { text: 'Monto', sortable: true, value: 'amount', align: 'center', divider: true, class: 'purple lighten-3' },
  { text: 'Comentario', sortable: true, value: 'comment', align: 'center', divider: true, class: 'purple lighten-3' },
  { text: '', sortable: true, value: 'actions', align: 'center', divider: true, class: 'purple lighten-3' }
]

const DEFAULT_SEARCH_PARAMS = {
  // typeDate: 1,
  dateFrom: null,
  dateTo: null,
  supervisors: [],
  providers: [],
  divisions: [],
  purchaseStatuses: [],
  columnSelected: []
}

const DEFAULT_PURCHASE_TRACKING_PAYLOAD = () => ({
  notificationDate: null,
  deliveryDays: null,
  collectionDate: null,
  status: null,
  isReturn: false
})

const DEFAULT_FREIGHT_PAYLOAD = () => ({
  freightProvider: null,
  dragGuide: null,
  amount: null,
  comment: null
})
const COMPLETED_STATUS = 'Complete'
const TRANSIT_STATUS = 'Transit'
const RETURN_STATUS = 'Return'
// const CANCELED_STATUS = 'Canceled'

const DEFAULT_CATALOGS = {
  supervisors: [],
  providers: [],
  requisitions: [],
  divisions: [],
  purchaseStatuses: [
    { text: 'Completo', value: 'Complete', class: 'green--text' },
    { text: 'Tránsito', value: 'Transit' },
    { text: 'Devolución', value: 'Return', class: 'orange--text' }
    // { text: 'Cancelado', value: 'Canceled', class: 'red--text' }
  ]
}

export {
  HEADERS, DEFAULT_SEARCH_PARAMS, FREIGHTS_HEADERS, DEFAULT_PURCHASE_TRACKING_PAYLOAD, DEFAULT_CATALOGS, DEFAULT_FREIGHT_PAYLOAD, CONCEPTS_HEADERS,
  COMPLETED_STATUS,
  TRANSIT_STATUS,
  RETURN_STATUS
}
